import useFetch from '@hooks/useFetch';
import { emptyObject } from '@constants/empty';
import { useRouter } from 'next/router';
import { getCompeteInfoKey } from '@cont/Compete/utils';

const useCompeteInfo = (
  options = {
    revalidateOnMount: false,
    fallbackData: undefined
  }
) => {
  const { query } = useRouter();

  const key = getCompeteInfoKey(query.goalUID);

  const { data, isValidating, mutate, ...rest } = useFetch(
    key,
    {},
    {
      revalidateOnMount: true,
      fallbackData: options.fallbackData
    }
  );

  return {
    key,
    data: data || emptyObject,
    faqs: data.faq,
    info: data.info,
    syllabus: data.syllabus,
    userCount: data.userCount,
    isValidating,
    mutate,
    ...rest
  };
};

export default useCompeteInfo;
